import { render, staticRenderFns } from "./statusbar-icon.vue?vue&type=template&id=3ba58889"
import script from "./statusbar-icon.vue?vue&type=script&lang=js"
export * from "./statusbar-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports